(() => {
  'use strict';
  const panel = document.querySelector('[data-bb-review-highlights]');
  if (!panel || panel.dataset.initialized === 'true') return;
  panel.dataset.initialized = 'true';
  const key = 'bb-review-highlights-v1';
  const cards = Array.from(panel.querySelectorAll('[data-review-id]'));
  const limit = 3;
  const firstDelay = 10000;
  const duration = 12000;
  const gap = 40000;
  let state;
  try {
    state = JSON.parse(sessionStorage.getItem(key) || '{}');
    state = {
      count: Number.isFinite(state.count) ? Math.max(0, state.count) : 0,
      dismissed: state.dismissed === true,
      nextAt: Number.isFinite(state.nextAt) ? state.nextAt : 0,
      seen: Array.isArray(state.seen) ? state.seen.filter(id => typeof id === 'string') : []
    };
    sessionStorage.setItem(key, JSON.stringify(state));
  } catch (_) {
    return; // Without session storage, leave popups off rather than repeat them.
  }
  if (!cards.length || state.dismissed || state.count >= limit) return;
  let timer;
  let visibleTimer;
  let shownAt = 0;
  let hovered = false;
  let stopped = false;
  let previousFocus;

  function refresh() {
    try {
      const latest = JSON.parse(sessionStorage.getItem(key) || '{}');
      state.count = Math.max(state.count, Number.isFinite(latest.count) ? latest.count : 0);
      state.dismissed = state.dismissed || latest.dismissed === true;
      state.nextAt = Math.max(state.nextAt, Number.isFinite(latest.nextAt) ? latest.nextAt : 0);
      state.seen = [...new Set([...state.seen, ...(Array.isArray(latest.seen) ? latest.seen.filter(id => typeof id === 'string') : [])])];
      return true;
    } catch (_) { stopped = true; panel.hidden = true; return false; }
  }

  function save() {
    try { sessionStorage.setItem(key, JSON.stringify(state)); return true; }
    catch (_) { stopped = true; panel.hidden = true; return false; }
  }

  function blocked() {
    return document.hidden || Array.from(document.querySelectorAll(
      'cart-drawer.active, cart-notification.active, .menu-opening, .rawa-widget.rawa-opened, ' +
      '[data-bb-share-open="true"], details-modal details[open], .product-media-modal[open], ' +
      '[role="dialog"][aria-modal="true"]:not([hidden])'
    )).some(element => {
      const style = getComputedStyle(element);
      return element.getClientRects().length > 0 && style.visibility !== 'hidden' && style.display !== 'none' && style.opacity !== '0';
    });
  }

  function schedule(delay) {
    clearTimeout(timer);
    if (!stopped && !state.dismissed && state.count < limit) timer = setTimeout(show, delay);
  }

  function hide() {
    panel.hidden = true;
    clearInterval(visibleTimer);
    cards.forEach(card => { card.hidden = true; });
    if (!stopped && !state.dismissed && state.count < limit) {
      state.nextAt = Math.max(state.nextAt, Date.now() + gap);
      if (save()) schedule(gap);
    }
  }

  function show() {
    if (!refresh()) return;
    if (stopped || state.dismissed || state.count >= limit) return;
    if (blocked()) { schedule(3000); return; }
    if (Date.now() < state.nextAt) { schedule(state.nextAt - Date.now()); return; }
    const pool = cards.filter(card => !state.seen.includes(card.dataset.reviewId));
    if (!pool.length) return;
    const card = pool[Math.floor(Math.random() * pool.length)];
    state.count += 1;
    state.seen.push(card.dataset.reviewId);
    state.nextAt = Date.now() + duration + gap;
    if (!save()) return;
    cards.forEach(item => { item.hidden = item !== card; });
    previousFocus = document.activeElement;
    hovered = false;
    shownAt = Date.now();
    panel.hidden = false;
    visibleTimer = setInterval(() => {
      if (blocked()) { hide(); return; }
      if (Date.now() - shownAt >= duration && !hovered && !panel.contains(document.activeElement)) hide();
    }, 500);
  }

  function dismiss() {
    state.dismissed = true;
    stopped = true;
    clearTimeout(timer);
    const focusedInside = panel.contains(document.activeElement);
    save();
    hide();
    if (focusedInside) {
      const target = previousFocus && previousFocus.isConnected && previousFocus !== document.body
        ? previousFocus : document.querySelector('#MainContent');
      target?.focus({ preventScroll: true });
    }
  }

  panel.querySelector('[data-review-close]').addEventListener('click', dismiss);
  panel.addEventListener('pointerenter', () => { hovered = true; });
  panel.addEventListener('pointerleave', () => { hovered = false; });
  panel.addEventListener('keydown', event => {
    if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); dismiss(); }
  });
  document.addEventListener('visibilitychange', () => {
    if (document.hidden && !panel.hidden) hide();
  });
  window.addEventListener('pagehide', () => {
    clearTimeout(timer); clearInterval(visibleTimer); panel.hidden = true;
  });
  window.addEventListener('pageshow', event => {
    if (event.persisted && refresh()) schedule(Math.max(firstDelay, state.nextAt - Date.now()));
  });
  schedule(Math.max(firstDelay, state.nextAt - Date.now()));
})();
